module.exports = __webpack_public_path__ + "h5/img/menu2.38878708.png";